export const appBuildNumber = '77';
